<template>
  <div id="QuizUpload" v-show="isCardActiveLocal">
    <div class="clickpagequizviewer">
      <div class="vx-row textcenter" v-if="question">
        <div class="vx-col w-full mb-2 disable-select">
          <h3>{{ question ? question.title : "" }}</h3>
        </div>
      </div>
      <div class="vx-row textcenter" v-if="question">
        <div class="vx-col w-full mb-2">
          <div v-html="question.questionText"></div>
        </div>
      </div>
      <div v-if="question.imageUrl" class="quizimage">
        <img :src="question.imageUrl" class="clickimageactive" style="width: 100% !important; height: 100%; border-radius:15px;">
      </div>
    </div>
    <div v-if="question.pinnedDocument" class="vx-row w-full downloadButton">
      <vs-button  color="success" class="downloadButton" type="filled" icon-pack="feather" icon="icon-download" @click.stop="downloadFile">Download</vs-button>
    </div>
    <div id="QuizUploadDownload" v-if="question.pinnedDocument" class="flex mb-2" style="flex-wrap: nowrap;">
      <div class="vx-col w-full">
        <p class="text-center mt-2" >{{fileName}}</p>
      </div>
    </div>
    <vs-divider>Upload Your Answer</vs-divider>
    <div class="vx-row mb-5" v-if="question">
      <div class="vx-col xl:w-1/2 lg:w-1/2 md:w-full sm:w-full xs:w-full w-full mx-auto">
        <file-pond
          v-show="true"
          id="filepond"
          ref="pond"
          :server="uploadLocation"
          label-idle="Drop upload file here or <span class='filepond--label-action'>Browse</span>"
          :allow-multiple="question.allowMultipleAnswers"
          :allow-image-preview="false"
          :accepted-file-types="types"
          :instant-upload="true"
          allowPaste=false
          @processfile="uploadComplete"
          />
        <p class="text-center" v-if="question.allowMultipleAnswers">Multiple Uploads Are Allowed</p>
        <vx-card class="w-full mb-2" v-for="(file,fileIndex) in uploadedFiles" :key="fileIndex">
          <div class="vx-row">
            <p style="align-self:center;" class="ml-2 product-name font-medium">{{uploadedFileName(file)}}</p>
            <vs-spacer></vs-spacer>
            <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-trash" style="float:right!important"  @click.stop="removeFileButton(file)"></vs-button>
          </div>
        </vx-card>
      </div>
      <vs-divider>Requested File Types</vs-divider>
      <div class="w-full mb-6">
        <p v-if="question.allowImage" class="text-center">Image</p>
        <p v-if="question.allowVideo" class="text-center">Video</p>
        <p v-if="question.allowDocuments" class="text-center">Document</p>
        <p v-if="question.allowAudio" class="text-center">Audio</p>
      </div>
    </div>
  </div>
</template>

<script>

  

  import vueFilePond from 'vue-filepond';
  import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
  import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
  const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);

  export default {
    components:{
      FilePond
    },
    data(){
      return{
        types:[],
        uploadedFiles:[]
      }
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      question: {
        type: Object,
        required: false
      },
      isStudent: {
        type: Boolean,
        required: false
      },
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;
          this.$emit("initValues");
        }
      },
    },
    computed: {
      isCardActiveLocal: {
        get() {
          if(this.question.uploadedFile && !Array.isArray(this.question.uploadedFile)){
            if(this.question.uploadedFile.includes(",")){
              this.uploadedFiles = this.question.uploadedFile.split(",");
            }
            else{
              this.uploadedFiles = [];
              this.uploadedFiles.push(this.question.uploadedFile);
            }
          }
          else if(this.question.uploadedFile && Array.isArray(this.question.uploadedFile)){
            var removeEmpty = this.question.uploadedFile.filter(y=>y);
            if(removeEmpty.length != 0){
              this.question.uploadedFile.forEach(element => {
                if(element.includes(",")){
                  var split = element.split(",");
                  split.forEach(val => {
                    this.question.uploadedFile = this.question.uploadedFile.filter(x=>!x.includes(val));
                    this.question.uploadedFile.push(val);
                  });
                  
                  this.uploadedFiles = this.question.uploadedFile;
                }
              });
              this.uploadedFiles = this.question.uploadedFile;
            }
            else{
              this.question.uploadedFile = [];
              this.uploadedFiles = [];
            }
          }
          else{
            this.uploadedFiles = [];
            this.question.uploadedFile = [];
          }
          if(!Array.isArray(this.question.uploadedFile)){
            var tempfile = this.question.uploadedFile;
            this.question.uploadedFile = []
            this.question.uploadedFile.push(tempfile);
          }
          this.getTypes();
          return this.isCardActive;
        },
        set(val) {
          if (!val) {
            this.$emit("initValues");
          }
        }
      },
      uploadLocation: {
        get() {
          return this.$buildUrl("tempupload");
        }
      },
      fileName(){
        var self = this;
        if(self.question.pinnedDocument){
          var size = self.question.pinnedDocument.length;
          var firstIndex = self.question.pinnedDocument.split("_")[0].length +1;
          var file = self.question.pinnedDocument.substring(firstIndex,size);
          return file
        }
        else{
          return ""
        }
      },
      
    },
    methods: {
      initValues(){
        this.types = [];
        this.uploadedFiles = [];
      },
      getTypes(){
        var self = this;
        self.types = [];
        if(self.question){
          if (self.question.allowAudio)
            self.types.push("audio/mp3");
          if (self.question.allowDocuments)
            self.types.push("application/pdf","application/msword", "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "text/plain","text/html","application/msaccess,application/vnd.ms-powerpoint","application/vnd.openxmlformats-officedocument.presentationml.presentation");
          if (self.question.allowImage)
            self.types.push("image/png", "image/jpg", "image/jpeg", "image/gif");
          if (self.question.allowVideo)
            self.types.push("video/mp4", "video/mov", "video/wmv","video/quicktime");
        }
        self.types = self.types;
      },
      uploadComplete(error, file) {
        var self = this;
        var allowMultipleAnswers = self.question.allowMultipleAnswers;
        var response = JSON.parse(file.serverId);
        if(response.url && allowMultipleAnswers){

          if(self.question.uploadedFile && !Array.isArray(self.question.uploadedFile)){
            var file = self.question.uploadedFile;
            self.question.uploadedFile = [];
            self.question.uploadedFile.push(file);
          }
          if(!self.question.uploadedFile){
            self.question.uploadedFile = []
          }
          self.question.uploadedFile = self.question.uploadedFile.filter(x=>x != null);
          self.question.uploadedFile.push(response.url);
          
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: "New File Saved",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-upload',
          });
          
        }else{
          self.question.uploadedFile = [];
          self.question.uploadedFile.push(response.url);
          
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: "New File Saved",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-upload',
          });
        }
        self.clearFilepond();
      },
      fileRemoved(error, file) {
        var self = this;
        var fileTobeDelted = file.file.name;
        self.question.uploadedFile = self.question.uploadedFile ? self.question.uploadedFile.filter(x=>!x.includes(fileTobeDelted)) : [];
      },
      downloadFile(){
        var self = this;
        window.open(self.question.pinnedDocument);
      },
      clearFilepond(){
        var self = this;
        if(this.$refs.pond){
          self.$refs.pond.getFiles().forEach(element => {
            self.$refs.pond.removeFile(element);
          });
        }
      },
      removeFileButton(file){
        var self = this;
        self.question.uploadedFile = self.uploadedFiles.filter(x=> !x.includes(file));
        self.$vs.notify({
          title:'Information',
          color: "warning",
          text: "File Removed",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-upload',
        });
      },
      uploadedFileName(name){
        var self = this;
        if(name){
          var size = name.length;
          var firstIndex = name.split("_")[0].length +1;
          var file = name.substring(firstIndex,size);
          return file
        }
        else{
          return name
        }
      }
    },
  };
</script>

<style lang="scss">
  #answerTextArea {
    height: 200px;
  }
  .vs-textarea{
    background: white !important;
    color: black !important;
  }
  #answerTextArea {
    .vs-component.vs-con-textarea.vs-textarea-primary{
    border-color: rgb(48, 48, 48) !important;
    }
    
  }

  .textcenter{
    text-align: center !important;
  }
  #QuizUpload{
    .downloadButton{
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .quizimage{
    width: 40%;
    max-height: 60%;
    display: flex;
    justify-content: center;
    margin: 0 auto;
    padding: 20px 0px;
  }

  @media screen and (max-width: 500px) {
    .quizimage{
      width: 80%;
      max-height: 90%;
    }
  }
</style>
